"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AppState = /** @class */ (function () {
    function AppState() {
        if (typeof document.hidden !== "undefined") {
            this.visibilityChange = "visibilitychange";
        }
        else if (typeof document['mozHidden'] !== "undefined") {
            this.visibilityChange = "mozvisibilitychange";
        }
        else if (typeof document['msHidden'] !== "undefined") {
            this.visibilityChange = "msvisibilitychange";
        }
        else if (typeof document['webkitHidden'] !== "undefined") {
            this.visibilityChange = "webkitvisibilitychange";
        }
        else {
            throw new Error('Page Visibility API not supported.');
        }
        document.addEventListener(this.visibilityChange, this.handleVisibilityChange, false);
    }
    AppState.getInstance = function () {
        if (!AppState.instance) {
            AppState.instance = new AppState();
        }
        return AppState.instance;
    };
    AppState.prototype.onBackground = function (callback) {
        this.onBackgroundCallback = callback;
        return this;
    };
    AppState.prototype.onForeground = function (callback) {
        this.onForegroundCallback = callback;
        return this;
    };
    AppState.prototype.handleVisibilityChange = function () {
        switch (document.visibilityState) {
            case "hidden":
                AppState.instance.onBackgroundCallback();
                break;
            case "visible":
                AppState.instance.onForegroundCallback();
                break;
        }
    };
    return AppState;
}());
exports.default = AppState;
//# sourceMappingURL=appState.js.map